import { ARRAY, NONEXISTENT_OPTIONS } from './constants';

/**
 * Checks if the provided argument is either `undefined`, `null`, or a falsy value.
 * Used to determine if a value is "nonexistent" or effectively disabled.
 * This includes false, 0, empty string, and NaN, which are treated as non-existent
 * for validation purposes (particularly useful for boolean flags where false means "disabled").
 *
 * @param {*} argument - The value to check.
 * @returns {boolean} - Returns `true` if the argument is `undefined`, `null`, or falsy, otherwise `false`.
 */
export function doesNotExist(argument) {
  return NONEXISTENT_OPTIONS.includes(argument) || Boolean(argument) === false;
}

/**
 * hasCorrectType checks that the provided value has the expected data type
 * @param {*} argument the value to check
 * @param {string} type the data type to validate the argument against
 * @returns {boolean} returns `true` if the argument passes the validation, otherwise `false`
 */
export function hasCorrectType(argument, type) {
  return type === ARRAY ? Array.isArray(argument) : typeof argument === type;
}

/**
 * parseArgumentName allows for retrieval of nested values inside of an object for validation
 * if the name is separate by periods, ex: `object.attribute.deeperAttribute`
 * @param {object} args a nested object traversable by the provided name
 * @param {string} name the name to be parsed
 * @returns {*} the value at the terminal access point of the provided name
 */
export function parseArgumentName(args, name) {
  let argument = args;
  // handling for nested attributes
  name.split('.').forEach(segment => (argument = argument[segment]));

  return argument;
}

export default {
  doesNotExist,
  hasCorrectType,
  parseArgumentName,
};
